// extracted by mini-css-extract-plugin
module.exports = {"checkedFilter":"select-menu_checkedFilter__2j7Rx"};